import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { DefaultFilter } from '../../teams/default-filters/default-filter.interface';

export class DefaultFilterService {
   async getDefaultFilters() {
      throw Error('Method not implemented');
   }

   async getDefaultFilter(clusterId: number) {
      const response = await http.get(`/clusters/${clusterId}/default-filters`, { params: { include_team_option: 'true' } });
      return response.data;
   }

   async postDefaultFilter(clusterId: number, defaultFilters: Array<DefaultFilter>) {
      const response = await http.post<ApiResource<DefaultFilter>>(`/clusters/${clusterId}/default-filters`, defaultFilters);
      return response.data;
   }

   async putDefaultFilter() {
      throw Error('Method not implemented');
   }

   async deleteDefaultFilterTeams(clusterId: number) {
      const response = await http.delete(`/clusters/${clusterId}/teams/default-filters`);
      return response.data;
   }
}
